(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["membership-tiers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hq-club-signup')) {
    customElements.define('hq-club-signup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-hq-club-signup]');
        this.form = this.querySelector('form');
        this.fields = this.querySelector('fieldset');
        this.email = this.querySelector('input[type="email"]');
        this.error = this.querySelector('[role="alert"]');
        this.status = this.querySelector('[data-hq-club-status]');
        this.success = this.querySelector('[data-hq-club-success]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };

        this.trigger.disabled = false;
        this.fields.disabled = false;
        this.trigger.addEventListener('click', () => {
          this.dialog.showModal();
          (this.success.hidden ? this.email : this.success).focus();
        }, options);
        this.querySelectorAll('[data-hq-club-close]').forEach(button => {
          button.addEventListener('click', () => this.dialog.close(), options);
        });
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) {
            this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('close', () => this.trigger.focus({ preventScroll: true }), options);
        this.email.addEventListener('input', () => {
          this.email.removeAttribute('aria-invalid');
          this.error.hidden = true;
        }, options);
        this.form.addEventListener('submit', event => this.subscribe(event), options);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        clearTimeout(this.timeout);
      }

      async subscribe(event) {
        event.preventDefault();
        if (this.pending || !this.success.hidden) return;
        this.email.value = this.email.value.trim();
        this.error.hidden = true;
        if (!this.email.checkValidity()) {
          this.email.setAttribute('aria-invalid', 'true');
          this.error.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.';
          this.error.hidden = false;
          this.email.focus();
          return;
        }

        this.email.removeAttribute('aria-invalid');
        this.pending = true;
        this.fields.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = 'Deine Anmeldung wird gesendet …';
        const request = new AbortController();
        this.request = request;
        this.timeout = setTimeout(() => request.abort(), 20000);

        try {
          // Public site ID, also used by the theme's back-in-stock form.
          // RRXCVX = SignUp_Welcome Flow, trigger for the live WC | LOYALTY SIGNUP flow.
          // Subscribe with consent; adding list membership alone would not grant consent.
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XL37kv', {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
              revision: '2026-07-15',
            },
            credentials: 'omit',
            signal: request.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'HQ Club Loyalty Page',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: this.email.value,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: 'RRXCVX' } } },
              },
            }),
          });
          if (response.status !== 202) {
            throw new Error(response.status === 429 ? 'rate-limit' : 'subscription-failed');
          }
          if (!this.isConnected) return;
          this.querySelector('[data-hq-club-entry]').hidden = true;
          this.success.hidden = false;
          this.form.reset();
          if (this.dialog.open) this.success.focus();
        } catch (error) {
          if (!this.isConnected) return;
          this.error.textContent = error.message === 'rate-limit'
            ? 'Bitte warte einen Moment und versuche es anschließend noch einmal.'
            : 'Deine Anmeldung konnte nicht bestätigt werden. Bitte prüfe deine Verbindung und E-Mail-Adresse und versuche es erneut.';
          this.error.hidden = false;
        } finally {
          clearTimeout(this.timeout);
          this.pending = false;
          this.fields.disabled = false;
          this.form.removeAttribute('aria-busy');
          this.status.textContent = '';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
const collapseGroups = document.querySelectorAll('.collapse_group button')

collapseGroups.forEach(collapseGroup => {
  collapseGroup.addEventListener('click', e => {
    const isExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true'
    e.currentTarget.setAttribute('aria-expanded', !isExpanded)

    const content = e.currentTarget.closest('.collapse_context')?.querySelector('.collapse_content')

    if (!content) return

    if (isExpanded)
      content.setAttribute('inert', '')
    else
      content.removeAttribute('inert')

    content.style.height = 
      isExpanded
        ? '0px'
        : `${Number.parseInt(content.querySelector('div').offsetHeight, 10)}px`
  })
})

  } catch(e) { console.error(e); }
})();
})();
